import { Link } from '@fluentui/react-components';
import React from 'react';

export interface FormattedLinkProps {
    href: string;
    target?: string;
    onClick?: () => void;
    chunks?: string;
}

const FormattedLink: React.FC<FormattedLinkProps> = (props) => {
    const { href, target, onClick, chunks } = props;
    return (
        <Link href={href} target={target} onClick={onClick}>
            {chunks}
        </Link>
    );
};

export const getFormattedMessageWithLinkValues = (
    href: string,
    onClick?: () => void,
    target = '_blank'
): { Link: (chunks: string) => JSX.Element } => {
    const values = {
        Link: (chunks: string) => <FormattedLink href={href} target={target} onClick={onClick} chunks={chunks} />,
    };
    return values;
};
